<template>
    <transition name="fade">
        <div class="call-back-app__thanks">
            <div class="call-back-app__thanks-message">
                <div class="call-back-app__thanks-title">Thank you!</div>
                <div class="call-back-app__thanks-txt">We will contact <br> you shortly.</div>
            </div>
            <div class="call-back-header__thanks-close-button" v-on:click="$emit('on-close-success-msg')">✖</div>
        </div>
    </transition>
</template>

<script>
    export default {
        data: function () {
            return {}
        },
    }

</script>

<style scoped>
    .call-back-app__thanks {
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        width: 275px;
        height: 280px;
        padding: 50px 0;
        text-align: center;
        border-radius: 4px;
        background-color: #fff;
        box-shadow: 0px 3px 40px 0px rgba(0, 0, 0, 0.15);
        overflow: hidden;
        position: absolute;
        bottom: 0;
        right: 0;
    }

    .call-back-app__thanks-message:after {
        content: "";
        position: absolute;
        bottom: 50px;
        left: 0;
        right: 0;
        margin: 0 auto;
        width: 75px;
        height: 70px;
        background-repeat: no-repeat;
        background-position: center;
        background-image: url("/dist/img/icon_write.gif");
    }

    .call-back-app__thanks-title {
        font-weight: 500;
        font-size: 20px;
        line-height: 28px;
        margin-bottom: 10px;
    }

    .call-back-app__thanks-txt {
        font-size: 16px;
        line-height: 23px;
    }

    .call-back-header__thanks-close-button {
        font-size: 14px;
        position: absolute;
        right: 17.5px;
        top: 10px;
        cursor: pointer;
    }

    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s;
    }
    .fade-enter, .fade-leave-to {
        opacity: 0;
    }

    @media (max-width: 768px){

        .call-back-app__thanks {
         right: 0;
         left: 0;
         position: fixed;
         top: 0;
         bottom: 0;
         margin: auto;
     }
    }
</style>


// WEBPACK FOOTER //
// app/Sites/AT/assets/js/vue/components/callback/ThankYouMessage.vue